module.exports = __webpack_public_path__ + "914456013336fcf29568802f4dbab5a2.svg";